import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Form, FormControlProps } from "react-bootstrap";
import styled from "styled-components";

interface PasswordInputProps extends FormControlProps {
  name: string;
}

const PasswordInput = ({
  onChange,
  isInvalid,
  value,
  onBlur,
  name,
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="position-relative">
      <Form.Control
        type={showPassword ? "text" : "password"}
        placeholder="Enter password"
        onChange={onChange}
        isInvalid={isInvalid}
        value={value}
        onBlur={onBlur}
        name={name}
      />
      <div
        className="position-absolute border-0"
        style={{ cursor: "pointer", zIndex: 10, right: 10, top: 7 }}
        onClick={() => setShowPassword(!showPassword)}
      >
        <FontAwesomeIcon
          className="text-primary"
          icon={showPassword ? faEyeSlash : faEye}
        />
      </div>
    </div>
  );
};

export default PasswordInput;
